export default {"src":"/_next/static/media/notecarrier.87cd1c2c.svg","height":256,"width":362,"blurWidth":0,"blurHeight":0};